import { requestAuth, request } from "common-frontend-components";
import { appConfig } from "../variables/appConfig";
export function callGetGalleryCategoryAssociationsAsync() {
    return request.get(`${appConfig.galleryCategoryAssociationsUrl}`);
}
export function callCreateGalleryCategoryAssociationAsync(data) {
    return requestAuth.post(`${appConfig.galleryCategoryAssociationsUrl}`, data);
}
export function callDeleteGalleryCategoryAssociationAsync(id) {
    return requestAuth.delete(`${appConfig.galleryCategoryAssociationsUrl}/${id}`);
}
//# sourceMappingURL=galleryCategoryAssociations.js.map